import { LoginValues } from '../infrastructure/StorageService';
import { StorageService } from '../infrastructure/StorageService';

/**
 * Application service for user credentials management
 */
export class UserCredentialsService {
  constructor(private storageService: StorageService) {}

  /**
   * Save user credentials
   */
  saveUserCredentials(userName: string, dbName: string, rememberMe: boolean): void {
    this.storageService.saveUserCredentials(userName, dbName, rememberMe);
    // Always save username for user preferences
    this.saveUserName(userName);
  }

  /**
   * Save username
   */
  saveUserName(userName: string): void {
    this.storageService.saveUserName(userName);
  }

  /**
   * Get saved credentials
   */
  getSavedCredentials(): LoginValues {
    return this.storageService.getSavedCredentials();
  }
}
